<script>
  import { db } from "../etc/firebase.js"
  import "materialize-css"
  import marked from "marked"
  import {
    btn_style_blue_d2,
    btn_style_lime_d3,
    btn_style_red_d2,
    btn_style_red_l3,
  } from "../etc/helpers.js"
  export let id = ""
  export let note = {}

  let editNote = false

  const deleteNote = () => {
    if (confirm("Are you sure to delete this News item?")) {
      db.collection("notes").doc(id).delete()

      alert("News Item Deleted!")
    } else {
      // No need for addition alert...
    }
  }

  const updateNote = () => {
    let updatedDT = new Date().getTime()

    db.collection("notes")
      .doc(id)
      .update({
        updatedDT: updatedDT,
        title: note.title,
        published: note.published,
        content: note.content,
      })
      .then(() => {
        //console.log("News item updated")
        alert("News item updated")
        editNote = false
        showDetail = false
      })
      .catch(() => {
        // console("@Note: updating New Items and Something went wrong!")
        alert("@Note: updating New Items and Something went wrong!")
      })
  }

  // The follow code is for DOM ops
  let showDetail = false
  // alert("record.qiGuaDT type is ->")
  // console.log(typeof record.qiGuaDT)
  function showHideNoteDetail() {
    showDetail = !showDetail
  }

  // Edit mode
  function enableEditMode() {
    editNote = true
  }

  const cancleEditNews = () => {
    editNote = false
  }

  let showForm = false
  function showNoteForm() {
    showForm = !showForm
  }
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<a class="blue-text collection-item" on:click={showHideNoteDetail}>
  {note.title}
</a>

<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showDetail ? 'block' : 'none'}"
  >
    <div class="note-box">
      <div class="show-note" style="display:{editNote ? 'none' : 'block'}">
        {@html marked(note.content)}
      </div>
      <div class="show-note" style="display:{editNote ? 'block' : 'none'}">
        <div id="update-news" class="">
          <h5>News Editor</h5>
          <br />
          <div id={"note-id-" + id}>
            <div class="">
              <label for="title">News Title</label>
              <input type="text" bind:value={note.title} required />
            </div>
            <div class="">
              <p>
                <label>
                  <input type="checkbox" bind:checked={note.published} />
                  <span>Go Publish</span>
                </label>
              </p>
              <br />
            </div>

            <div class="markdown-text">
              <label for="markdown">News Content</label>
              <textarea
                class="white"
                bind:value={note.content}
                placeholder="Enter markdown text here"
              />
            </div>

            <div class="btn-row">
              <button class={btn_style_blue_d2} on:click={updateNote}
                >Update News</button
              >
              <button class={btn_style_red_l3} on:click={cancleEditNews}
                >Cancel</button
              >
            </div>
          </div>

          <!-- Convert the markdown to HTML and display it -->
          <div class="preview">{@html marked(note.content)}</div>
        </div>
      </div>
      <br />
      <div class="btn-row" style="display:{editNote ? 'none' : 'block'}">
        <button class={btn_style_blue_d2} on:click={enableEditMode}>Edit</button
        >
        <button class={btn_style_red_l3} on:click={showHideNoteDetail}
          >Cancel</button
        >
        <button class={btn_style_red_d2 + " right"} on:click={deleteNote}
          >Delete</button
        >
      </div>
    </div>
  </div>
</div>

<!-- </li> -->
<style>
  .note-box {
    /* display: grid;
    grid-template-columns: 3fr 1fr; */
  }
  .note-title {
    width: 100%;
  }
  .note-content {
    margin: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #note-content {
    background-color: white;
  }
  .note {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
  }
  .btn-row {
    display: flex;
    /* grid-template-columns: 1fr 1fr; */
  }
  .btn-row button {
    width: 100px;
    margin: 10px;
    text-align: center;
    /* line-height: 75px; */
    /* font-size: 30px; */
  }
  .btn_single {
    margin-right: 30px;
  }
  textarea,
  .preview {
    box-sizing: border-box;
    display: block;
    width: 100%;
  }

  textarea {
    font-family: monospace, Roboto;
    height: 200px;
    border: none;
    margin: 0;
    padding: 1rem;
  }

  .preview {
    height: 75%;
    padding: 2rem;
    border-top: solid 2px #888;
  }
</style>
